var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}]},_vm._l((_vm.blok.block),function(childBlok){return _c('StoryblokComponent',{key:childBlok._uid,attrs:{"blok":childBlok}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }